import styled from 'styled-components';

export const StyledLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;
